<template>
  <div id="app">
    <main>
      <div class="page-loader" style="z-index:99999;">
        <div class="loader">Loading...</div>
      </div>
      <Navbar />
      <!-- The social media icon bar -->
      <div class="icon-bar-social" id="socialNav">
        <a href="https://discordapp.com/invite/halfhumangames" target="_blank" rel="noopener noreferrer"><img src="/static/assets/images/discord4.png" alt="dwerve"></a> 
        <a href="https://twitter.com/intent/user?screen_name=HalfHumanGames" target="_blank" rel="noopener noreferrer"><img src="/static/assets/images/twitter4.png" alt="dwerve"></a> 
        <a href="https://www.facebook.com/HalfHumanGames/" target="_blank" rel="noopener noreferrer"><img src="/static/assets/images/facebook4.png" alt="dwerve"></a> 
        <a href="https://www.instagram.com/halfhumangames/" target="_blank" rel="noopener noreferrer"><img src="/static/assets/images/instagram.png" alt="dwerve"></a> 
         <a href="https://www.reddit.com/r/halfhumangames/" target="_blank" rel="noopener noreferrer"><img src="/static/assets/images/reddit.png" alt="dwerve"></a> 
        <a href="https://www.youtube.com/channel/UCT6Iqrqj8ZmolRj1yDBN3EQ?sub_confirmation=1" target="_blank" rel="noopener noreferrer"><img src="/static/assets/images/youtube4.png" alt="dwerve"></a> 
         
      </div>
      <router-view/>
    </main>
    <SendyModal />
   <div class="scroll-up" id="scroll-up"><a href="#" v-scroll-to="{ element: '#navbar', duration: 800, easing: 'easing', offset: -20 }"><i class="fa fa-chevron-circle-up"></i></a></div>
  </div>
</template>

<script>
import SendyModal from "@/views/Home/SendyModal.vue";
import Home from "@/views/Home/Home.vue";
import Home2 from "@/views/Home/Home2.vue";
import Navbar from "@/views/Home/Navbar.vue";
export default {
  name: "App",
  components: {
    Home,
    Navbar,
    Home2,
    SendyModal
  },
  mounted(){
     $(window).on("load", function() {
        $(".loader").fadeOut();
        $(".page-loader").delay(350).fadeOut("slow")
        document.querySelector("nav.navbar").style.marginTop = 0
    });

  }
};
</script>

<style>
.swalHow {
    width: 100% !important;
    max-width: 446px !important;
}
.swal2-styled.swal2-confirm[aria-label="pointLink"] {
    background: none;
    margin-bottom: 10px;
    margin-top: -10px;
}
strong.swalPledgeTitle {
    font-family: 'Titillium Web', sans-serif;
    font-size: 22px;
    padding: 8px;
}
a.refPointLink:hover {
    text-decoration: none;
}
.swal2-styled.swal2-confirm[aria-label="pointLink"]:hover {
    background-image: none;
}
.swal2-styled.swal2-confirm[aria-label="pointLink"]:focus {
    box-shadow: none;
}
ul.pointList {
    list-style: decimal;
    padding-left: 5px;
    font-family: 'Titillium Web', sans-serif;
    text-align: left;
    margin-left: 18px;
    font-size: 16px;
    min-width: 284px;
}
ul.pointList li {
    line-height: 1.3;
    margin-bottom: 13px;
}
a.refPointLink {
    color: #fff;
    padding: 6px 16px;
    background: linear-gradient(-135deg, #1fd28d, #05ce78);
    box-shadow: 7px 3px 15px 0 rgb(0 0 0 / 21%);
    border-radius: 5px;
    font-family: 'Titillium Web', sans-serif;
    font-size: 16px;
    font-weight: 800;
}
.vm--modal {
    width: 100% !important;
    height: 100% !important;
    background-color: rgb(0 0 0 / 45%) !important;
    left: 0 !important;
    top: 0 !important;
}
button.swal2-confirm[aria-label="Wishlist!"] {
    padding: 0;
}
.swalSteamLink {
    border-radius: 4px;
    display: block;
    background: linear-gradient( to right, #75b022 5%, #588a1b 95%);
    padding: 0px 16px;
    color: #fff;
    font-size: 21px;
    box-shadow: 1px 7px 13px 8px rgba(224, 224, 224, 0.75);
    font-family: Digitalt;
    text-shadow: 1px 1px 2px #081a42;
}
.swalSteamLink:hover {
    text-decoration: none;
    color: #fff;
}
.swalSteamTitle {
    font-size: 25px;
    font-weight: 100;
    padding: 10px;
    font-family: Digitalt;
}
.featured+.site-content {
    z-index: -1;
    margin-top: 100vh;
}
div#swal2-content {
    font-size: 16px;
}
form.form {
    width: 100%;
    max-width: 600px;
    margin-right: auto;
    margin-left: auto;
}
/* Mailtrain styles */
.form-group.email label {
  display: none;
}
.form-group {
  display: inline-block;
  margin-right: -6px;
  width: 64%;
}
form.form button {
    background-color: #33adff;
    font-size: 19px;
    height: 53px;
    position: relative;
    right: 0;
    z-index: 0;
    margin-bottom: 4.6px;
    display: inline-block;
    padding-right: 10px !important;
    padding-left: 10px !IMPORTANT;
    padding: 0;
    border: unset;
    width: 96px;
    overflow: hidden;
    color: #fff;
    font-family: Digitalt;
    font-weight: 400;
    text-align: center;
    white-space: nowrap;
    vertical-align: middle;
}
.form-group.email input {
  font-family: Roboto Condensed,sans-serif;
    display: inherit;
    padding: 0 5px;
    color: #000;
    font-size: 16px;
    height: 53px;
    border: 1px solid #eaeaea;
    position: relative;
    z-index: 0;
    width: 100%;
    left: 0;
    margin-bottom: 0;
    border-radius: 0;
    transition: all .4s ease-in-out 0s;
}
.form-group.email label {
  display: none;
}
/* div#mailtrain-subscription-widget-rJfit7pAM h3 {
  display: none;
} */
.mailtrain-subscription-widget h3 {
  display: none;
}
@media only screen and (min-device-width: 600px) and (max-device-width: 780px) {
  form.form button {
    font-size: 19px;
  }
}
@media only screen and (min-device-width: 600px) and (max-device-width: 780px) {
  form.form button {
    font-size: 19px;
  }
}
@media only screen and (min-device-width: 300px) and (max-device-width: 600px) {
  form.form button {
    height: 39px;
  }
  .form-group.email input {
    height: 39px;
  }
}
@font-face {
  font-family: Digitalt;
  font-display: swap;
  src: url(/static/assets/lib/Digitalt.otf);
}

/* DEBUG: Disable until links can actual go to other sites */
/* #navbar {
  display: none;
} */
.input-group {
  z-index: 1;
}
.scroll-up a {
  background: none !important;
  opacity: 1 !important;
}

.scroll-up i {
  color: #33adff;
}

.dwerve-logo {
  margin-top: -8px;
}
div#custom-collapse {
  margin-top: 4px;
}
.navbar1 {
  display: block;
}
a.suscribeBtn:hover {
  background-color: #3498dc !important;
}
.suscribeBtn::before,
.suscribeBtn::after {
  position: absolute;
  content: "";
  transition: all 0.5s;
}
.suscribeBtn {
  display: inline-block;
  padding: 20px 40px;
  color: white;
  position: absolute;
  top: 50%;
  left: 69%;
  margin-top: 31px;
  transform: translate(-50%, -50%);
  vertical-align: middle;
  font-family: Digitalt, sans-serif;
  text-decoration: none;
  font-size: 2vw;
  transition: all 0.5s;
  background-color: #3498db;
}
.suscribeBtn::before {
  bottom: -5px;
  height: 5px;
  width: 100%;
  left: 2px;
  transform: skewX(45deg);
  background-color: #196090;
}
.suscribeBtn::after {
  right: -5px;
  height: 100%;
  width: 5px;
  bottom: -3px;
  transform: skewY(45deg);
  background-color: #124364;
}
.suscribeBtn:active {
  margin-left: 3px;
  margin-top: 31px;
}
.suscribeBtn:active::before {
  bottom: -5px;
  height: 5px;
  left: 3px;
}
.suscribeBtn:active::after {
  right: -5px;
  width: 5px;
  bottom: -3px;
}
ul.nav.navbar-nav.navbar-left {
  font-family: Grandmaster;
}

@font-face {
  font-family: Grandmaster;
  src: url(/static/assets/lib/Grandstander-clean.otf);
}
@media (max-width: 468px) {
  ul.nav.navbar-nav.navbar-left {
    padding-top: 19px;
  }
  /* .suscribeList {
    padding-right: 35px !important;
  } */
}
@media (min-width: 781px) {
  .navbar-right {
    float: right !important;
    margin-right: 29px;
  }
}
@media (width: 768px) {
  .navbar-right {
    float: right !important;
    margin-right: 4px !important;
  }
}
@media (max-width: 890px) {
  .navbar-custom {
    font-size: 17px;
  }
}

.icon-bar-social {
  -webkit-transition: left 0.6s;
  transition: left 0.6s;
  position: fixed;
  top: 82px;
  right: 20px;
  width: 32px;
  float: left;
  z-index: 9999;
  left: 100%;
}
.icon-bar-social a:hover {
  animation: shake 0.5s;
  animation-iteration-count: infinite;
}
@keyframes shake {
  0% {
    transform: translate(1px, 1px) rotate(0deg);
  }
  10% {
    transform: translate(-1px, -2px) rotate(-1deg);
  }
  20% {
    transform: translate(-2px, 0px) rotate(1deg);
  }
  30% {
    transform: translate(2px, 2px) rotate(0deg);
  }
  40% {
    transform: translate(1px, -1px) rotate(1deg);
  }
  50% {
    transform: translate(-1px, 2px) rotate(-1deg);
  }
  60% {
    transform: translate(-2px, 1px) rotate(0deg);
  }
  70% {
    transform: translate(2px, 1px) rotate(-1deg);
  }
  80% {
    transform: translate(-1px, -1px) rotate(1deg);
  }
  90% {
    transform: translate(1px, 2px) rotate(0deg);
  }
  100% {
    transform: translate(1px, -2px) rotate(-1deg);
  }
}
/* Style the icon bar links */
.icon-bar-social a {
  display: block;
  text-align: center;
  margin-bottom: 10px;
  transition: all 0.3s ease;
  color: white;
  padding: 0;
  font-size: 10px;
}

@media only screen and (width: 1024px) {
  .icon-bar-social {
    top: 23%;
  }
}
@media (max-width: 854px) {
  .nav > li {
    text-align: center;
  }
  .suscribeBtn {
    left: 50%;
    float: left;
  }
  ul.nav.navbar-nav.navbar-left {
    margin-top: 35px;
  }
}
.facebook {
  background: #3b5998;
  color: white;
}

.twitter {
  background: #55acee;
  color: white;
}

.google {
  background: #dd4b39;
  color: white;
}

.linkedin {
  background: #007bb5;
  color: white;
}

.youtube {
  background: #bb0000;
  color: white;
}
@media only screen and (max-width: 450px) {
  .suscribeBtn {
    left: 53%;
    font-size: 4vw;
  }
  .nav > li > a {
    padding: 9px 23px;
  }
}
@media only screen and (max-width: 750px) {
  .form-group {
  width: 48% !important;
}
}

/* Mailtrain styles */
.form-group.email label {
  display: none;
}
.form-group {
  display: inline-block;
}
form.form button {
  background-color: #33adff;
  font-size: 23px;
  height: 53px;
  position: absolute;
  right: 0;
  z-index: 2;
  margin-bottom: 3.6px;
  padding: 6.5px 15px;
  border: unset;
  color: #fff;
  font-family: Digitalt;
  font-weight: normal;
  text-align: center;
  white-space: nowrap;
  vertical-align: middle;
}
.form-group.email input {
  font-family: Roboto Condensed, sans-serif;
  display: table-cell;
  padding: 0 5px;
  color: black;
  font-size: 16px;
  height: 53px;
  border: 1px solid #eaeaea;
  position: absolute;
  z-index: 2;
  width: 85%;
  left: 0;
  margin-bottom: 0;
  border-radius: 0px;
  transition: all 0.4s ease-in-out 0s;
}
.form-group.email label {
  display: none;
}
/* div#mailtrain-subscription-widget-rJfit7pAM h3 {
  display: none;
} */
.mailtrain-subscription-widget h3 {
  display: none;
}
h3.cta-title {
  display: block;
}
@media only screen and (min-device-width: 600px) and (max-device-width: 780px) {
  form.form button {
    font-size: 19px;
  }
}
@media only screen and (min-device-width: 300px) and (max-device-width: 600px) {
  form.form button {
    font-size: 12px;
    height: 39px;
  }
  .form-group.email input {
    height: 39px;
  }
  .cta-subtitle {
    padding-top: 32px;
  }
}
.scene,
.sliderhome,
.wrapper {
	overflow: hidden
}
.sliderhome,
body.intro>.featured {
	height: 100vh
}

.featured {
	transition: height .5s
}

body>.featured {
	height: 68px;
	transform-style: flat
}

.sliderhome {
	width: 100%;
	position: relative;
	z-index: 1;
	background-color: #bbb
}

.sliderhome .btn-link,
.sliderhome a {
	font-weight: 900;
	color: #fff;
	text-transform: uppercase
}

.sliderhome .selector {
	height: 10vh;
	background: rgba(41, 49, 59, .8);
	width: 100%;
	position: absolute;
	bottom: 0;
	text-align: center;
	line-height: 9vh;
	min-height: 50px
}

.sliderhome .selector img {
	position: relative;
	bottom: 100%;
	height: 200%;
	margin: 0 auto
}


.sliderhome .selector a.outside {
	position: absolute;
	bottom: -100%;
	right: 1em;
	padding: 0;
	height: 50%;
	top: -100%;
	margin: auto;
	display: block
}

.sliderhome .game-featured.current {
	transition: opacity ease .65s;
	opacity: 1
}

.sliderhome .game-featured {
	opacity: 0
}

.game-featured {
	transform-style: flat!important;
	-webkit-backface-visibility: hidden;
	backface-visibility: hidden;
	background-repeat: no-repeat;
	width: 100%;
	height: 100vh;
	background-size: cover;
	position: fixed;
	left: 0;
	right: 0;
	max-height: inherit
}

.game-featured .layer {
	position: absolute;
	width: 100%;
	background-size: cover;
	height: 100%
}

.text-scroll {
	text-shadow: 0 0 8px #082f77;
	position: absolute;
	bottom: 100px;
	margin: auto;
	left: 0;
	right: 0;
	z-index: 42543;
	text-align: center;
	color: #fff;
	font-size: 44px;
	font-weight: 900;
	text-transform: uppercase;
	pointer-events: auto
}

.text-scroll-inner>.btn {
	font-size: 20px
}

.text-scroll-inner {
	width: 90%;
	margin: 0 auto;
	text-align: center
}

.scene {
	pointer-events: none
}

.scene.current {
	pointer-events: auto
}

.layer,
.scene {
	position: absolute;
	height: 100vh;
	min-width: 100%;
	padding: 0;
	margin: 0
}

.layer img {
	position: absolute;
	left: -40px;
	right: -40px;
	top: -40px;
	bottom: -40px;
	object-fit: cover;
	max-width: unset
}

@media all and (min-aspect-ratio:16 / 9) {
	/* .layer img {
		min-width: 110%;
		height: 110%
	} */
}

.w100,
nav.navbar {
	width: 100%
}

@media all and (max-aspect-ratio:16 / 9) {
	/* .layer img {
		min-width: 110%;
		height: 110%
	} */
}

.layer h1.text {
	font-size: 3rem;
	position: relative;
	top: 45%;
	text-align: center;
	text-shadow: 0 0 5px rgba(0, 0, 0, .3)
}


.wrapper {
	position: absolute;
	min-width: 100%;
	left: 0;
	top: 0;
	flex: 1 0 auto
}



nav.navbar {
	position: fixed;
	top: 0;
	transition: top ease-in .3s;
	min-height: 68px
}

body.intro>nav.navbar {
	top: -68px
}

.navbar-brand {
	margin-right: 0;
	padding-top: .5rem
}

.navbar-toggler {
	font-size: 2rem
}

.navbar-nav .nav-item.dropdown {
	margin-right: -.5rem
}

@media(max-width:767px) {
	.navbar-nav .nav-item+.nav-item {
		margin-left: 0
	}
	.navbar-left,
	.navbar-nav.nav .nav-item,
	.navbar-right {
		display: block;
		float: none
	}
	.navbar-toggleable-sm {
		clear: both
	}
	.nav.navbar-nav>[class^=col-] {
		float: none
	}
}

.nav-item.position-absolute {
	display: inline-block
}

.nav-item.position-absolute a {
	color: #bbb!important
}

@media(min-width:768px) and (max-width:991px) {
	.nav-item.position-absolute {
		display: none
	}
}

.dropdown-menu a {
	line-height: 1.75rem
}
.navbar-nav .dropdown-menu a {
	font-weight: 700;
	color: #3b4751;
	font-size: .8rem;
	transition: color .2s ease
}

.navbar-nav .dropdown-menu a:hover {
	color: #ff711d;
	background: 0;
	text-decoration: none
}

.navbar-nav .dropdown-toggle {
	color: #ccc
}

.navbar-nav .dropdown-toggle:hover,
.navbar-nav .dropdown.open>.dropdown-toggle {
	color: #ff711d
}

.navbar-nav .dropdown-menu {
	background-color: #f7f7f9;
	border-radius: 0;
	border: 0;
	box-shadow: 4px 4px 0 rgba(0, 0, 0, .4)
}
html {
  overflow-y: scroll;
  overflow-x: hidden;
  -ms-overflow-style: scrollbar;
}
body {
  background: #12152c;
  font: 400 12px/1.8 "Open Sans", sans-serif;
  color: #666;
  -webkit-font-smoothing: antialiased;
}
img {
  max-width: 100%;
  height: auto;
}
.module,
.module-small {
  position: relative;
  padding: 140px 0;
  background-repeat: no-repeat;
  background-position: 50% 50%;
  background-size: cover;
}
.module-small {
  padding: 70px 0;
  border-bottom: 9px double #0f0a06;
  border-top: 9px double #0f0a06;
}
.bg-dark {
  background: #05070b;
}
@media only screen and (min-device-width: 300px) and (max-device-width: 600px) {
    .info p {
        font-size: 16px;
        line-height: 1;
        left: 0;
    }
}
h3.cta-title {
  display: block;
}
@media only screen and (min-device-width: 600px) and (max-device-width: 780px) {
  #heroheader form.form button {
    font-size: 24px;
  }
}
@media only screen and (min-device-width: 300px) and (max-device-width: 600px) {
  #heroheader form.form button {
    font-size: 24px;
    height: 39px;
  }
  #heroheader .form-group.email input {
    height: 39px;
  }
  .cta-subtitle {
    padding-top: 32px;
  }
}
.page-loader {
  position: fixed;
  background: rgb(51, 173, 255);
  bottom: 0;
  right: 0;
  left: 0;
  top: 0;
  z-index: 9998;
}
.loader {
  position: absolute;
  border-left: 3px solid #0cffff;
  border-top: 2px solid rgba(255, 255, 255, 0.2);
  border-right: 2px solid rgba(255, 255, 255, 0.2);
  border-bottom: 2px solid rgba(255, 255, 255, 0.2);
  height: 46px;
  width: 46px;
  left: 50%;
  top: 50%;
  margin: -23px 0 0 -23px;
  text-indent: -9999em;
  font-size: 10px;
  z-index: 9999;
  -webkit-animation: load 0.8s infinite linear;
  -moz-animation: load 0.8s infinite linear;
  ms-animation: load 0.8s infinite linear;
  o-animation: load 0.8s infinite linear;
  animation: load 0.8s infinite linear;
}
.loader,
.loader:after {
  border-radius: 50%;
  width: 54px;
  height: 54px;
}
@-webkit-keyframes load {
  0% {
    -webkit-transform: rotate(0deg);
    transform: rotate(0deg);
  }
  100% {
    -webkit-transform: rotate(360deg);
    transform: rotate(360deg);
  }
}
@keyframes load {
  0% {
    -webkit-transform: rotate(0deg);
    transform: rotate(0deg);
  }
  100% {
    -webkit-transform: rotate(360deg);
    transform: rotate(360deg);
  }
}
.navbar {
  min-height: 50px !important;
}
.navbar-custom {
  background-color: rgba(0, 8, 29, 0.73);
  border: 0;
  position: fixed;
  top: -100px;
  width: 100%;
  display: block;
  transition: top 0.6s;
  border-radius: 0;
  z-index: 2;
  padding-bottom: 11px !important;
  font-weight: 700;
  font-family: "Rubik One", sans-serif;
  text-transform: uppercase;
  letter-spacing: 1px;
  line-height: 38px;
  font-size: 23px;
}
.nav > li > a {
  position: relative;
  display: block;
  padding: 9px 9px;
}
@media (min-width: 768px) {
  .navbar > .container .navbar-brand,
  .navbar > .container-fluid .navbar-brand {
    margin-left: -141px;
  }
}
a.navbar-brand {
  margin-right: 7px;
}
.navbar a {
  transition: color 0.125s ease-in-out 0s;
}
.navbar-custom .dropdown-menu {
  background: rgba(26, 26, 26, 0.9);
  border-radius: 0;
  border: 0;
  padding: 0;
  box-shadow: none;
}
.navbar-custom .navbar-brand {
  letter-spacing: 4px;
  font-weight: 400;
  font-size: 22px;
  color: #fff;
}
.navbar-custom .nav li > a {
  position: relative;
  color: #fff;
  font-size: 23px;
  text-shadow: 0 3px 0px rgba(39, 130, 193, 0.97), 0px 8px 13px rgba(52, 149, 216, 0.16), 0px 18px 23px rgba(204, 54, 54, 0);
}
.navbar-custom .dropdown-menu > li > a {
  border-bottom: 1px solid rgba(73, 71, 71, 0.15) !important;
  padding: 11px 15px;
  letter-spacing: 2px;
  color: #999;
}
.navbar-custom .dropdown-menu .dropdown-menu {
  border-left: 1px solid rgba(73, 71, 71, 0.15);
  left: 100%;
  right: auto;
  top: 0;
  margin-top: 0;
}
.navbar-custom .dropdown-menu.left-side .dropdown-menu {
  border: 0;
  border-right: 1px solid rgba(73, 71, 71, 0.15);
  right: 100%;
  left: auto;
}
.navbar-custom .nav > li > a:focus,
.navbar-custom .nav > li > a:hover,
.navbar-custom .nav .open > a,
.navbar-custom .nav .open > a:focus,
.navbar-custom .nav .open > a:hover,
.navbar-custom .dropdown-menu > li > a:focus,
.navbar-custom .dropdown-menu > li > a:hover {
  background: 0;
  color: #fff;
}
.navbar-custom .dropdown-menu > li > a:hover {
  background: rgba(255, 255, 255, 0.1) !important;
}
.navbar-custom .dropdown-toggle:after {
  position: absolute;
  display: block;
  right: 0;
  top: 50%;
  margin-top: -6px;
  font-display: swap;
  font: normal normal normal 14px/1 FontAwesome;
  font-size: 9px;
  content: "\f107";
  text-rendering: auto;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
}
.navbar-custom .navbar-toggle .icon-bar {
  background: #fff;
}
.dropdown-menu {
  min-width: 180px;
  font-size: 11px;
}
.home-section {
  position: relative;
  background-color: #fff;
  background-repeat: no-repeat;
  background-position: center center;
  width: 100%;
  z-index: 0;
  background-size: cover;
}

.banner-img {
  margin-top: -145px;
}
.shop-page-header:before {
  background: rgba(34, 34, 34, 0.3);
}
.footer {
  padding: 10px 0;
}
.footer .copyright {
  margin: 0;
}
.footer .footer-social-links {
  text-align: right;
}
.footer .footer-social-links a {
  display: inline-block;
  padding: 0 6px;
}
@media (min-width: 768px) {
  .navbar-transparent {
    background: rgba(0, 8, 29, 0.73);
    padding-bottom: 0px;
    padding-top: 0;
  }
  .navbar-custom .dropdown-menu {
    position: absolute;
    display: block;
    visibility: hidden;
    opacity: 0;
  }
  .navbar-custom .open > .dropdown-menu {
    visibility: visible;
    opacity: 1;
  }
  .navbar-custom .dropdown-menu .dropdown-toggle:after {
    position: absolute;
    display: block;
    right: 9px;
    top: 50%;
    font-display: swap;
    margin-top: -6px;
    font: normal normal normal 14px/1 FontAwesome;
    font-size: 9px;
    content: "\f105";
    text-rendering: auto;
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
  }
  .navbar-right .dropdown-menu {
    right: auto;
    left: 0;
  }
  .comment .comment {
    margin-left: 75px;
  }
}
 .footer {
    text-align: center;
  }
  .copyright,
  .footer-social-links {
     text-align: left;
    margin: 10px 0;
  }
  .widget .widget-title {
    font-size: 14px;
    text-shadow: 2px 2px #080808;
    padding: 0 0 10px;
    margin: 0 0 15px;
    font-family: Grandmaster;
    text-transform: uppercase;
    letter-spacing: 2px;
    line-height: 1.4;
    font-weight: 400;
    color: #fff;
}
</style>



// WEBPACK FOOTER //
// src/App.vue